import React from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import "./Modal.css";

// # This modal can take HTML as content, making it very versatile, and reusable

export const Modal = ({
  title,
  content,
  accept,
  reject,
  acceptText = "generic.agree",
  rejectText = "generic.cancel",
  loading = false,
  acceptButtonColor = null,
}) => {
  const { t } = useTranslation();
  const modalRoot = document.querySelector("#modalroot");
  return createPortal(
    <div className="Modal__background">
      <div className="Modal__element">
        <div className="Modal__header">
          <div className="Modal__title">
            <div className="Modal__title-text">{title}</div>
          </div>
        </div>
        <div className="Modal__content">
          <div className="Modal__content-text">{content}</div>
        </div>
        <div className="Modal__actions">
          <button
            className="Modal__actions-button Modal__actions-button--reject"
            onClick={reject}
          >
            {t(rejectText)}
          </button>
          <button
            disabled={loading}
            className="Modal__actions-button Modal__actions-button--accept"
            style={{ backgroundColor: acceptButtonColor }}
            onClick={accept}
          >
            {t(acceptText)}
          </button>
        </div>
      </div>
    </div>,
    modalRoot
  );
};
